import { render, staticRenderFns } from "./CustomTaskFilter.vue?vue&type=template&id=ac1ea40a"
import script from "./CustomTaskFilter.vue?vue&type=script&lang=js"
export * from "./CustomTaskFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports